import { gql } from '@apollo/client';

export const COMPLETE_QUIZ = gql(/*GraphQL*/ `
  mutation CompleteQuiz($id: ID!) {
    completeQuiz(id: $id) {
      id
      isCompleted
    }
  }
`);
